import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { CountryService } from '../../../../../app/shared/API-Service/services/country.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import { Image } from '../../../../../images/images'
import { BaseComponent } from 'src/app/shared/components/base/base.component';


@Component({
  selector: 'app-view-country',
  templateUrl: './view-country.component.html',
  styleUrls: ['./view-country.component.css']
})
export class ViewCountryComponent extends BaseComponent implements OnInit {
  countries:object [] = [];

  constructor(private _CountryService:CountryService, private _Router:Router) { super()}

  ngOnInit(): void {
    this.getcountries();
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getcountries();
  }
  getcountries(){
    this._CountryService.GetCountryPaged(this.pager).subscribe((res) => {
      this.countries = res.data.items;
      this.totalCount=res.data.totalCount;
    
    },(err)=>{
    },() =>{
    });
  }
  update(data){
    this._CountryService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertCountry']);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._CountryService.DeleteCountry(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getcountries();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }

}
